import React, { FC } from 'react'
import { SettingsAccordion, SettingsAccordionItem } from 'components/Accordion'
import { CardInner, ScheduleConfirmCard, SettingsWarningCard } from 'components/Card'
import format from 'date-fns/format'
import { parseToDate } from 'lib/helper'
import ja from 'date-fns/locale/ja'
import { Spacer } from 'components/Utility'
import { ScheduleType } from 'types/schedule'
import { StockType } from 'types/stock'

type Props = {
  addedStocks: StockType[]
  breadName: string
  expandStatus: string
  imageUrl: string
  resetExpandedStatus: () => void
  preorderSchedules: ScheduleType[]
  deletedStocks: StockType[]
}

const ScheduleCollectiveConfirmCard: FC<Props> = (props) => {
  const { addedStocks, breadName, expandStatus, imageUrl, resetExpandedStatus, preorderSchedules, deletedStocks } =
    props

  return (
    <SettingsAccordion
      breadName={breadName}
      expandStatus={expandStatus}
      imageUrl={imageUrl}
      resetExpandedStatus={resetExpandedStatus}
    >
      <SettingsAccordionItem>
        <ScheduleConfirmCard schedules={preorderSchedules} />
        <CardInner>
          {addedStocks.length > 0 && (
            <>
              <SettingsWarningCard
                description={'以下の受渡可能日が新しく登録されます。'}
                content={addedStocks
                  .map((stock) => format(parseToDate(stock.date), 'M月d日（E）', { locale: ja }))
                  .join(', ')}
                title={'追加される受渡可能日'}
                type={'info'}
              />
              <Spacer size={4} />
            </>
          )}
          {deletedStocks.length > 0 && (
            <>
              <SettingsWarningCard
                description={'以下の受渡可能日は削除され、お客さまが購入できなくなります。'}
                content={deletedStocks
                  .map((stock) => format(parseToDate(stock.date), 'M月d日（E）', { locale: ja }))
                  .join(', ')}
                title={'削除される受渡可能日'}
              />
              <Spacer size={4} />
            </>
          )}
          <Spacer size={8} />
        </CardInner>
      </SettingsAccordionItem>
    </SettingsAccordion>
  )
}

export default ScheduleCollectiveConfirmCard
